module.exports = __webpack_public_path__ + "fonts/Nightmare Codehack.22fa76c6.otf";